import React, { useContext } from "react";
import * as d3 from 'd3';

import * as dateish from "js/dateish";
import { speciesDayOfYear, speciesStreaks, streakDays } from "js/ebird/agg";

import DataTable from "web/ui/data_table";
import TaxonLink from "web/ui/taxon_link";
import { Observation } from "js/ebird/ebird";
import { DatabaseContext } from "web/db_context";

import classes from './bird_table.module.css';

type Props = { allObservations: Observation[] }

const BirdTable = ({ allObservations }: Props) => {
  const taxonomy = useContext(DatabaseContext)!.taxonomy;

  const countable = allObservations.filter(o => o.taxon.speciesCode);
  const byStreaks = speciesStreaks(countable);
  const byDoY = speciesDayOfYear(countable);

  const rows = byStreaks.map(([spcode, streaks]) => {
      const bestStreak = streaks[0];
      const taxon = taxonomy.code(bestStreak[0].taxon.speciesCode!); // TODO: speciesTaxon property - differentiate speciesCode and ID from taxon
      return { taxon, bestStreak, doyMap: byDoY.get(spcode)! };
    })
    .sort((a, b) => b.doyMap.size - a.doyMap.size)
    // .sort((a, b) => streakDays(b.bestStreak) - streakDays(a.bestStreak))
    .map((r, i) => {
      const start = r.bestStreak[0], [end] = r.bestStreak.slice(-1);
      const streak = `${streakDays(r.bestStreak)} (${dateish.yearMonDay(start.date)} => ${dateish.yearMonDay(end.date)})`;
      return [
        i+1,
        <TaxonLink taxon={r.taxon} />,
        r.doyMap.size,
        streak
      ];
    });

  return <DataTable klass={ classes.birding } header={['#', 'Bird', 'Days of Year', 'Best Streak']} rows={rows} />;
}

export default BirdTable
